import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate, useParams} from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import {HiOutlineQrcode} from "react-icons/hi";

import {BsCalendar4Week} from "react-icons/bs";
import Barcode from 'react-barcode';

import {LuPackageSearch} from "react-icons/lu";
import {LiaEyeSolid} from "react-icons/lia";
import {IoMdCheckmarkCircleOutline} from "react-icons/io";
import {MdEditSquare} from "react-icons/md";
import {FaCubes} from "react-icons/fa";

function ROrderDetails2() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [order, setOrder] = React.useState([]);
    const [code, setCode] = React.useState('');

    const [result, setResult] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(true);
    const [description, setDescription] = React.useState('');
    const [documentFile, setDocumentFile] = React.useState(null);


    React.useEffect(() => {

        const params = {
            'processFor' : 'Sales',
            'returned' : 1
        }

        API.getOrder(params , id)
            .then((response) => {
                setOrder(response.data);

                setIsLoaded(true);

            })
            .catch((error) => {

                if(error.response) {
                    toast.error(error.response.data.message);
                    setTimeout (() => {

                    },400)
                }
                else {
                    toast.error(error.message);
                    setTimeout (() => {

                    },400)
                }
            });


    }, [id , result]);




    const onAddButtonClick =  () => {
        setIsLoaded(false);
        const request = {
            order_id: id,
            'processFor' : 'Vendors',
            code,
            'returned' : 1
        }
        API.OrderUpdate( request )
            .then((response) => {
                toast.success(response.message);
                setCode('');

                const params = {
                    'processFor' : 'Vendors',
                    'returned' : 1
                }

                API.getOrder(params , id)
                    .then((response) => {
                        setOrder(response.data);

                        setIsLoaded(true);

                    })
            })
            .catch((error) => {
                setIsLoaded(true);
                toast.error(error.response.data.message)
            });
    }
    const onStatusButtonClick =  (statusId) => {
        setIsLoaded(false);
        const request = {
            'order_id': id,
            'status_id' : statusId,
            description,
            'processFor' : 'Sales',
            'calc_battery_count' : 1
        }
        API.updateStatus( request )
            .then((response) => {
                toast.success(response.message);
                setTimeout(() => {
                    navigate('/returned-orders/');
                }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setIsLoaded(true);
            });
    }


    const onDocChange = (event) => {
        setDocumentFile(event.target.files[0])
    }
    const onUploadClick = () => {
        const formData = new FormData();
        const file = documentFile;

        if (file) {
            if(file.size > 10085760) {
                toast.error('حجم فایل ارسالی نمی تواند بیشتر از 10 مگابایت باشد');
                return false;
            }
            formData.append('excel_file', file);
            formData.append('order_id', id);

        } else {
            toast.error('لطفا ابتدا یک فایل معتبر انتخاب کنید!');
            return false;
        }



        API.uploadFileReturn(formData)
            .then((response) => {
                toast.success(response.message);
                setResult(response.data)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            });
    }
    return (
        <React.Fragment>
            <Header/>

            <Navbar page="createreturn"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        مدیریت سفارش
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                        <div className="col-1">
                                            <HiOutlineQrcode />
                                        </div>
                                        <div className="col-5 text-small-2">
                                            کد یکتای درخواست:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order.tracking_code}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 pb-2 ">
                                        <div className="col-1">
                                            <BsCalendar4Week />
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تاریخ ثبت
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.date}
                                        </div>
                                    </div>
                                    {
                                        order?.last_status?.id === 1 &&
                                    <div className="row card bg-success-subtle">

                                        <div className="col-12 border-bottom pt-4 text-center fw-bold text-small-2 pb-2 mb-3 text-success">
                                            افزودن تکی باتری به لیست مرجوعی ها
                                        </div>
                                        <div className="col-12">

                                            <div className="">
                                                <div className="card-body py-4">
                                                    <div className="row">
                                                        <div className="col-md-9">
                                                            <div className="form-floating mb-3">
                                                                <input type="number" className="form-control text-center" id="floatingInput" placeholder="کد"
                                                                       autoFocus={true}
                                                                       value={code}
                                                                       onChange={(val) => {
                                                                           setCode(val.target.value)
                                                                       }}
                                                                />
                                                                <label htmlFor="floatingInput">کد باتری</label>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-3 pt-2">
                                                            <button className="btn btn-success w-100 py-2"
                                                                    onClick={onAddButtonClick}
                                                            >
                                                              افزودن به محموله
                                                                <LuPackageSearch className='float-start mt-1' />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>



                                    </div>
                                    }
                                    {
                                        order?.last_status?.id === 1 &&
                                    <div className="row card bg-info-subtle mt-4">

                                        <div className="col-12 border-bottom pt-4 text-center fw-bold text-small-2 pb-2 mb-3 text-dark">
                                            افزودن گروهی باتری از طریق فایل اکسل
                                        </div>
                                        <div className="col-12">

                                            <div className="">
                                                <div className="card-body py-4">
                                                    <div className="d-flex align-items-center">
                                                        <p className='p-2 mt-2 fw-bold text-muted border-bottom pb-3 w-100'>
                                                            <MdEditSquare className='mx-2 text-success text-big-3'/>
                                                            برای افزودن گروهی باتری کد مربوط به باتری های مورد نظر را
                                                            در قالب یک فایل
                                                            اکسل ارسال بفرمایید.
                                                            <a href="https://api.ngkh.ir/storage/app/media/ngkh-returned.xlsx"
                                                               target="_blank"
                                                               className='mx-3 text-decoration-underline'
                                                               rel="noreferrer">
                                                                دانلود فایل اکسل نمونه
                                                            </a>
                                                        </p>


                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-9 ">
                                                            <label className="custom-file-upload" role='button'>
                                                                انتخاب فایل اکسل
                                                                <input type="file" onChange={onDocChange}
                                                                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                                />
                                                            </label>

                                                            <div
                                                                className=" text-success text-small-2  bg-light mt-2 p-1 text-center">
                                                                &nbsp;
                                                                {
                                                                    documentFile ?
                                                                        " فایل انتخاب شده : " +
                                                                        documentFile.name
                                                                        : ''
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className="col-md-3 text-left mt-3">
                                                            <button className="btn btn-primary  w-100"
                                                                    onClick={onUploadClick}>

                                                                آپلود فایل
                                                                <FaCubes className='float-start mt-1' />
                                                            </button>
                                                        </div>
                                                        {
                                                            result &&
                                                        <div className="col-12 mt-4 text-center bg-warning-subtle p-2">


                                                                    تعداد باتری اضافه شده:
                                                                    &nbsp;
                                                                    <strong
                                                                        className='text-success'>{result.correct}
                                                                        &nbsp;
                                                                     باتری
                                                                    </strong>
                                                                    &nbsp;
                                                                    -
                                                                    &nbsp;
                                                                    تعداد باتری دارای خطا (اضافه نشده)
                                                                    &nbsp;
                                                                    <strong
                                                                        className='text-danger'>{result.error}
                                                                        &nbsp;
                                                                        باتری
                                                                    </strong>
                                                                    <div className='mt-3'>
                                                                        <a href={"https://api.ngkh.ir/storage/app/uploads/public/return/return" + id + ".txt"} target="_blank" rel="noreferrer">
                                                                            دانلود فایل گزارش
                                                                        </a>
                                                                    </div>


                                                        </div>
                                                    }
                                                    </div>
                                                </div>
                                            </div>

                                        </div>


                                    </div>
                                    }
                                    <div className="row mx-2 mt-2">
                                        <div className="col-md-12 mt-4">


                                            <div className="form-floating">
                                    <textarea className="form-control" placeholder="توضیحات" id="floatingTextarea"
                                              value={description}
                                              onChange={
                                                  (event) => {
                                                      setDescription(event.target.value)
                                                  }
                                              }
                                    >

                                    </textarea>
                                                <label htmlFor="floatingTextarea" className="right-0">
                                                    توضیحات سفارش
                                                </label>
                                            </div>

                                        </div>
                                        <div className="col-12">
                                            {
                                                order?.last_status?.id === 1 &&
                                                <div className="row">
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        &nbsp;
                                                    </div>
                                                    <div className="col-md-3 p-2 mt-5  ">
                                                        &nbsp;
                                                    </div>

                                                    <div className="col-md-6 p-2 mt-5  ">
                                                        <button
                                                            className="btn btn-warning text-center text-semi-big w-100 p-2 pr-4 "
                                                            onClick={
                                                                () => {
                                                                    onStatusButtonClick(14)
                                                                }
                                                            }
                                                            disabled={!isLoaded}
                                                        >
                                                            ارسال محموله مرجوعی ها
                                                        </button>
                                                    </div>
                                                </div>
                                            }

                                        </div>


                                    </div>



                                        <div className="row mx-2 mb-3 pb-2 list-battery">
                                            <div className="col-12 text-small-2 border-bottom pb-2 text-primary">
                                                باتری ها
                                            </div>
                                            <div className="col-12">
                                                <div className='my-4'>
                                                 <span className='alert alert-primary fade show text-small-2 py-1' role='button'
                                                       onClick={() => navigate(`/rorder-batteries/${id}`)}
                                                 >
                                                گزارش وضعیت باتری های این سفارش
                                                     &nbsp;
                                                     <LiaEyeSolid />
                                            </span>
                                                </div>
                                                <div className="row">
                                                    {
                                                        order?.details?.batteries?.map(bt => {
                                                            return (
                                                                <div className="col-3  px-3 mt-3">
                                                                    <div className='bg-white rounded p-1'

                                                                         onClick={() => {
                                                                             setCode(bt)
                                                                         }}
                                                                    >
                                                                        <Barcode value={bt} height={20} width={1} fontSize={12}/>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>


                                </div>
                            </div>

                        </div>
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">تاریخچه وضعیت های محموله مرجوعی</h5>
                                    <div className="row">
                                        {
                                            order?.history?.map(stat => {
                                                return (
                                                    <div className='col-12 mt-2 bg-light text-small-1  p-2'>
                                                        <IoMdCheckmarkCircleOutline className='mx-2'
                                                                                    style={{color:stat.status.color }}
                                                        />
                                                        سفارش در تاریخ:
                                                        &nbsp;
                                                        {stat.date}
                                                        &nbsp;
                                                        توسط
                                                        &nbsp;
                                                        {stat.user.name}
                                                        &nbsp;
                                                        {stat.user.surname}
                                                        &nbsp;
                                                        در وضعیت
                                                        &nbsp;
                                                        <span className='fw-bold' style={{color:stat.status.color }}>
                                                            {stat.status.title}
                                                        </span>

                                                        &nbsp;
                                                        قرار گرفت.

                                                        <div className='fw-bold text-muted me-4 text-small-2 mt-3'>
                                                            {stat.description.length > 2 ? stat.description : ''}
                                                        </div>
                                                    </div>
                                                )

                                            })

                                        }
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default ROrderDetails2;